import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_45 } from "@/lib/programData";
export default function DesiertoAtlas45Page() {
  return <ProgramTemplate program={PROGRAM_45} variant="da" showJourneyChronology />;
}
